export const SELECTABLE_SUBTYPES = [
  {
    label: 'Quick serve',
    value: 'concessions-pos',
  },
  {
    label: 'Tabs',
    value: 'tabs-pos',
  },
  {
    label: 'Kiosk',
    value: 'kiosk',
  },
  {
    label: 'Suites',
    value: 'suites-pos',
  },
  {
    label: 'Xpedite',
    value: 'xpedite',
  },
]

export const FUSE_OPTIONS = {
  threshold: 0.1,
  location: 0,
  distance: 100,
  maxPatternLength: 32,
  minMatchCharLength: 1,
  keys: ['label'],
}
